//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowCTABlockSx",
    props: {
        ...defaultBlockProps,
    },
    data: () => ({}),
};
